export default __webpack_public_path__ + "static/media/cart.57bebce9.svg";